import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";

const Manifesto = () => {
  const { t } = useLanguage();
  return (
    <section id="manifesto" className="px-6 py-28 md:px-12 md:py-40" data-testid="manifesto-section">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-neon">{t.manifesto.kicker}</p>
          <h2 className="font-display text-4xl font-extrabold uppercase tracking-tight sm:text-5xl lg:text-6xl">
            {t.manifesto.title}
          </h2>
        </Reveal>
        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-12">
          {t.manifesto.chapters.map((c, i) => (
            <Reveal
              key={c.n}
              delay={i * 0.12}
              className={i === 0 ? "md:col-span-5" : i === 1 ? "md:col-span-7" : "md:col-span-6 md:col-start-4"}
            >
              <div className="group h-full border border-white/10 bg-surface p-10 transition-colors duration-500 hover:border-neon/50 md:p-12" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="font-mono text-6xl font-bold transition-colors duration-500 md:text-7xl" style={{ color: "#B794FF" }}>
                  {c.n}
                </span>
                <h3 className="mt-8 font-display text-2xl font-bold uppercase tracking-tight md:text-3xl">{c.t}</h3>
                <p className="mt-4 max-w-md text-sm leading-relaxed text-muted2 md:text-base">{c.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
